import Vue from 'vue'
import { invalidateUrl } from '@appbase/util';
import { Component, Prop } from 'vue-property-decorator'
import { ReserveResourceMode } from '@reserve/types';
import ewsApi from '@reserve/api/resource-ews'
import fileApi from '@/api/file'
import fileViewer from '@appbase/util/doc-viewer-helper'
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'

@Component({
    computed: mapGetters({
        user: accountTypes.USER
    })
})
export default class Attachments  extends Vue {
    @Prop({ type: Number }) mode!: ReserveResourceMode;
    @Prop({ type: String }) resource!: string;
    @Prop({ type: String }) reserveId!: string;
    @Prop({ type: String }) fileType!: 'EWS' | 'DB';
    @Prop({ type: String }) fileCode!: string;
    @Prop({ type: Array }) files!: ewsResource.EwsAttachment[] | appbase.FileInfo[]

    user!: account.User;

    download(file: ewsResource.EwsAttachment | appbase.FileInfo, idx: number) {      
        if(this.fileType === 'EWS') {
            this.downloadEws(file as ewsResource.EwsAttachment, idx);
        } else {
            this.downloadDb(file as appbase.FileInfo, idx);
        }
    }

    downloadEws(file: ewsResource.EwsAttachment, idx: number) {
        var iframeDownloads = this.$refs.refAttachment as HTMLIFrameElement[];
        var iframeDownload = iframeDownloads[idx];

        const url = invalidateUrl('/cm/Mail/Attachment/api/download');
        const itemId = encodeURIComponent(this.fileCode);
        const fileId = encodeURIComponent(file.id);
        const downloadurl = `${url}?itemId=${itemId}&attachmentID=${fileId}`;
        iframeDownload.src = downloadurl;
    }

    downloadDb(file: appbase.FileInfo, idx: number) {
        var iframeDownloads = this.$refs.refAttachment as HTMLIFrameElement[];
        var iframeDownload = iframeDownloads[idx];

        const url = invalidateUrl('/cm/File/Download');
        const fileCode = encodeURIComponent(this.fileCode);
        const filename = encodeURIComponent(file.name);
        const downloadurl = `${url}?code=${fileCode}&filename=${filename}`;
        iframeDownload.src = downloadurl;
    }

    deleteFile(file: ewsResource.EwsAttachment | appbase.FileInfo, idx: number) {
        let deletePromise: Promise<boolean> = Promise.resolve(false);

        if(this.fileType === 'EWS') {
            let ewsFile = file as ewsResource.EwsAttachment;
            deletePromise = ewsApi.deleteAttachment(this.fileCode, [ ewsFile.id ])
        } else {            
            let dbFile = file as appbase.FileInfo;
            console.log('dbFile', dbFile);
            let codeValues = [ dbFile.value, dbFile.value2, dbFile.value3, dbFile.value4, dbFile.value5 ]
                .filter(v => !(v == null || v.trim().length == 0));
            deletePromise = fileApi.deleteFiles(
                'create',
                dbFile.code, 
                codeValues, 
                [ dbFile.name ],
                dbFile.serverPath ? [ dbFile.serverPath ] : []).then(res => true);
        }

        deletePromise.then(res => {
            if(res) {
                this.$emit('fileRemoved', file, idx);
            }
        });
    }

    openViewer(file: ewsResource.EwsAttachment | appbase.FileInfo) {      
        if(file.type === 'EWS') {
            let email = this.mode == ReserveResourceMode.Read ? this.resource : this.user.email;
            let ewsFile = (file as ewsResource.EwsAttachment);
            let attachmentService = invalidateUrl('/cm/Mail/Attachment/api/viewerDownload')
            let reserveId = encodeURIComponent(this.reserveId);
            let attachmentId = encodeURIComponent(ewsFile.id);
            let fullUrl = `${location.origin}${attachmentService}?itemId=${reserveId}&attachmentID=${attachmentId}&email=${email}`

            fileViewer.open(file.name, fullUrl, false);
        } else {
            fileViewer.openCode(file.name, this.fileCode, false);
        }        
    }  
}